<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("view") }} {{ $tc("cinema", 1) }} {{ $t("tickettemplates") }}
      </div>
      <div>
        <router-link
          v-if="$can('update', 'Cinema Ticket Templates')"
          to
          @click.native="goToRoute('/master/edit-cinema-ticket-templates')"
          class="btn-blue"
          >{{ $t("edit") }}</router-link
        >
        <router-link class="btn-blue" to="cinema-ticket-templates"
          >{{ $t("tickettemplates") }} {{ $tc("list", 1) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="row mb-3">
        <!-- v-if="ticketDetails.temp_tt_id == 2 && ticketDetails.temp_tt_id != 3 ? true : ticketDetails.temp_tt_id != 2 && ticketDetails.temp_tt_id != 3 ? true : false" -->
        <!-- class="col-md-6" -->
        <div
          class="col-md-6"
          v-if="ticketDetails.temp_id == 1"
          :class="ticketDetails.temp_id == 1 ? 'col-md-12' : ''"
        >
          <div class="row justify-content-center">
            <div
              class="mr-1"
              style="height: 410px; width: 104px; position: relative"
              v-for="(x, xk) in ticketDetails.temp_no_of_copies_id"
              :key="xk"
            >
              <div
                class="print-tickets"
                style="transform: rotate(90deg); transform-origin: 52px 50%"
              >
                <table
                  border="0"
                  style="width: 410px; line-height: 1; border: 1px solid"
                >
                  <tr>
                    <td colspan="3" style="padding: 2px 10px">
                      <table style="width: 100%">
                        <tr>
                          <td style="vertical-align: top">
                            <p
                              style="
                                font-size: 18px;
                                font-weight: 600;
                                margin: 0;
                              "
                            >
                              P
                            </p>
                          </td>
                          <td>
                            <p
                              style="
                                font-size: 14px;
                                font-weight: 600;
                                margin: 0 0 5px 0;
                              "
                            >
                              <span v-if="ticketDetails.temp_cinema_name == 'Y'"
                                >Cinema Name</span
                              >
                              <span
                                v-if="ticketDetails.temp_show_address == 'Y'"
                                >(Address)</span
                              >
                            </p>
                            <p
                              style="
                                font-size: 14px;
                                font-weight: 600;
                                margin: 0;
                                display: flex;
                                justify-content: space-between;
                              "
                            >
                              <span>Movie Title</span>
                              <span
                                style="
                                  font-size: 12px;
                                  margin: 0px 0px 5px;
                                  letter-spacing: 0.3px;
                                "
                                >Transaction No: 8765432190</span
                              >
                            </p>
                            <span style="font-size: 14px; margin: 0px 0px 5px"
                              >Issued on: 17-Jan-2020 5:00:00 PM</span
                            >
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 33.35%; padding: 2px 10px 2px 10px">
                      <p style="font-size: 16px; font-weight: 600; margin: 0">
                        Total: 300 INR
                      </p>
                    </td>
                    <td
                      style="
                        width: 33.33%;
                        padding: 2px 10px 2px 10px;
                        vertical-align: top;
                      "
                    >
                      <p
                        v-if="ticketDetails.temp_datetime == 'Y'"
                        style="
                          font-size: 14px;
                          font-weight: 600;
                          margin: 0 0 5px 0;
                        "
                      >
                        Fri, 17-01-20
                      </p>
                      <p
                        v-if="ticketDetails.temp_datetime == 'Y'"
                        style="
                          font-size: 14px;
                          font-weight: 600;
                          margin: 0 0 10px 0;
                        "
                      >
                        6:00 PM
                      </p>
                    </td>
                    <td
                      style="
                        width: 33.33%;
                        padding: 2px 10px 2px 10px;
                        vertical-align: bottom;
                      "
                    >
                      <span v-if="ticketDetails.temp_seat_type == 'Y'"
                        >Seat Type:&nbsp;</span
                      >
                      <span v-if="ticketDetails.temp_seat_name == 'Y'"
                        >Seat Name</span
                      >
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- v-if="ticketDetails.temp_tt_id == 3 && ticketDetails.temp_tt_id != 2 ? true : ticketDetails.temp_tt_id != 2 && ticketDetails.temp_tt_id != 3 ? true : false" -->
        <!-- d-flex justify-content-center -->
        <div
          class="col-md-6"
          v-if="ticketDetails.temp_id == 3"
          :class="
            ticketDetails.temp_id == 3
              ? 'col-md-12 d-flex justify-content-center'
              : ''
          "
        >
          <table
            style="
              width: 302px;
              border: 1px solid;
              font-size: 12px;
              padding: 10px 0;
            "
          >
            <tr v-if="ticketDetails.temp_cinema_name == 'Y'">
              <td colspan="2" style="text-align: center; font-size: 14px">
                <strong>Cinema Name</strong>
              </td>
            </tr>
            <tr v-if="ticketDetails.temp_show_address == 'Y'">
              <td colspan="2" style="text-align: center">
                <span>Cinema Address Here</span>
              </td>
            </tr>
            <tr v-if="ticketDetails.temp_contact_number == 'Y'">
              <td colspan="2" style="text-align: center">
                <span>P.No. - 9022461985</span>
              </td>
            </tr>
            <tr v-if="ticketDetails.temp_email == 'Y'">
              <td colspan="2" style="text-align: center">
                <span>Email - support@cinema.com</span>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="text-align: center">
                <span>Transaction No: 1234567890</span>
              </td>
            </tr>
            <!-- TICKET SPACER -->
            <tr>
              <td colspan="2" style="padding: 10px"></td>
            </tr>
            <tr>
              <td colspan="2" style="font-size: 14px; padding: 0 5px">
                <strong>Movie Title</strong>
              </td>
            </tr>
            <tr>
              <td
                v-if="ticketDetails.temp_screen_name == 'Y'"
                style="padding: 0 5px"
              >
                <span>Screen Name</span>
              </td>
              <td
                v-if="ticketDetails.temp_seat_type == 'Y'"
                style="padding: 0 5px"
              >
                <span>Seat Type</span>
              </td>
            </tr>
            <tr v-if="ticketDetails.temp_seat_name == 'Y'">
              <td colspan="2" style="padding: 0 5px">
                Seat Name:
                <strong>J1, J2, J3, J4</strong>
              </td>
            </tr>
            <tr v-if="ticketDetails.temp_datetime == 'Y'">
              <td colspan="2" style="padding: 0 5px">
                <span>Show Date & Time</span>
              </td>
            </tr>
            <!-- TICKET SPACER -->
            <tr>
              <td colspan="2" style="padding: 10px"></td>
            </tr>

            <!-- FNB BILLING -->
            <tr v-if="ticketDetails.temp_fnb_bill == 'N'">
              <td style="width: 80%; padding: 0 5px">
                <p style="margin-bottom: 0">Pepsi</p>
                <p style="margin-bottom: 0">Coke</p>
                <p style="margin-bottom: 0">Burger</p>
              </td>
              <td style="width: 20%; padding: 0 5px">
                <p style="margin-bottom: 0">100</p>
                <p style="margin-bottom: 0">100</p>
                <p style="margin-bottom: 0">100</p>
              </td>
            </tr>
            <!-- MOVIE TICKETS BILLING -->
            <tr v-if="ticketDetails.temp_tax_details == 'Y'">
              <td style="width: 80%; padding: 0 5px">
                <p style="margin-bottom: 0">VAT (5%)</p>
                <p style="margin-bottom: 0">GST</p>
              </td>
              <td style="width: 20%; padding: 0 5px">
                <p style="margin-bottom: 0">30</p>
                <p style="margin-bottom: 0">10</p>
              </td>
            </tr>

            <!-- BILLING FINAL TOTAL -->
            <tr>
              <td colspan="2" style="padding: 5px">
                <hr style="margin: 0" />
              </td>
            </tr>
            <tr>
              <td style="width: 80%; padding: 0 5px">
                <strong>Total Amount</strong>
              </td>
              <td style="width: 20%; padding: 0 5px">
                <strong>1000</strong>
              </td>
            </tr>

            <!-- TICKET SPACER -->
            <tr>
              <td colspan="2" style="padding: 10px"></td>
            </tr>

            <tr v-if="ticketDetails.temp_special_instruction == 'Y'">
              <td colspan="2" style="padding: 5px">
                <strong style="display: block">Instructions</strong>
                Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                Assumenda aliquam quasi, totam minima similique eos iusto iste
                ratione, dolor ullam, laudantium perspiciatis enim. Beatae, odit
                quae! Fugit perspiciatis ex temporibus?
              </td>
            </tr>

            <tr v-if="ticketDetails.temp_qrcode == 'Y'">
              <td colspan="2" style="text-align: center">
                <img
                  src="@/assets/img/icons/Qr-4.png"
                  height="50"
                  width="50"
                  alt="QR Code"
                />
              </td>
            </tr>

            <!-- TICKET SPACER -->
            <tr>
              <td colspan="2" style="padding: 10px"></td>
            </tr>
          </table>
        </div>

        <!-- Third Template -->

        <div
          class="col-md-6"
          v-if="ticketDetails.temp_id == 2"
          :class="
            ticketDetails.temp_id == 2
              ? 'col-md-12 d-flex justify-content-center'
              : ''
          "
        >
          <table
            v-for="(x, xk) in ticketDetails.temp_no_of_copies_id"
            :key="xk"
            style="width: 300px; border: 1px solid #000; font-size: 12px"
          >
            <tr>
              <td colspan="5" style="text-align: center; padding-top: 20px">
                <strong v-if="ticketDetails.temp_cinema_name == 'Y'"
                  >MAS CINEMAS - IRAQ</strong
                >
                <p v-if="ticketDetails.temp_cinema_name == 'Y'">Cinemas Name</p>
              </td>
            </tr>

            <tr>
              <td colspan="5" style="padding-bottom: 15px">
                <table style="width: 100%; text-align: center">
                  <tr>
                    <td style="width: 33.33%">
                      <p style="margin: 0">Transaction Id</p>
                      <strong>12345</strong>
                    </td>
                    <td
                      v-if="ticketDetails.temp_datetime == 'Y'"
                      style="width: 33.33%"
                    >
                      <p style="margin: 0">Date</p>
                      <strong>23-01-2020</strong>
                    </td>
                    <td
                      v-if="ticketDetails.temp_datetime == 'Y'"
                      style="width: 33.33%"
                    >
                      <p style="margin: 0">Time</p>
                      <strong>6:40pm</strong>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td colspan="5" style="padding-bottom: 15px">
                <table style="width: 100%">
                  <tr>
                    <td style="width: 70%; padding: 0 5px">
                      <p style="margin: 0">Movie</p>
                      <strong>Avengers End Game</strong>
                    </td>
                    <td
                      v-if="ticketDetails.temp_screen_name == 'Y'"
                      style="width: 30%; padding: 0 5px"
                    >
                      <p style="margin: 0">Screen</p>
                      <strong>Screen 2</strong>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr
              v-if="ticketDetails.temp_tax_details == 'Y'"
              style="text-align: center"
            >
              <td colspan="2" style="width: 25%; padding-bottom: 15px">
                <p style="margin: 0">Restriction</p>
                <strong>18+</strong>
              </td>
              <td style="width: 25%; padding-bottom: 15px">
                <p style="margin: 0">Ticket</p>
                <strong>500</strong>
              </td>
              <td style="width: 25%; padding-bottom: 15px">
                <p style="margin: 0">VAT</p>
                <strong>00</strong>
              </td>
              <td style="width: 25%; padding-bottom: 15px">
                <p style="margin: 0">Total</p>
                <strong>500.00</strong>
              </td>
            </tr>

            <tr v-else style="text-align: center">
              <td style="width: 25%; padding-bottom: 15px">
                <p style="margin: 0">Restriction</p>
                <strong>18+</strong>
              </td>
              <td style="width: 25%; padding-bottom: 15px">
                <p style="margin: 0">Ticket</p>
                <strong>500</strong>
              </td>
              <td style="width: 25%; padding-bottom: 15px">
                <p style="margin: 0">VAT</p>
                <strong>00</strong>
              </td>
              <td style="width: 25%; padding-bottom: 15px">
                <p style="margin: 0">Total</p>
                <strong>500.00</strong>
              </td>
            </tr>

            <tr>
              <td colspan="5" style="padding-bottom: 20px">
                <table style="width: 100%">
                  <tr>
                    <td
                      v-if="ticketDetails.temp_seat_type == 'Y'"
                      style="padding: 0 5px"
                    >
                      <span style="margin: 0">Class:</span>
                      <strong>Normal</strong>
                    </td>
                    <td
                      v-if="ticketDetails.temp_seat_name == 'Y'"
                      style="padding: 0 5px"
                    >
                      <span style="margin: 0">Seats:</span>
                      <strong>E1, E2, E3,</strong>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>

        <div
          class="col-md-6"
          v-if="ticketDetails.temp_id == 4"
          :class="
            ticketDetails.temp_id == 4
              ? 'col-md-12 d-flex justify-content-center'
              : ''
          "
        >
          <table
            style="width: 100%; max-width: 320px; border: 1px solid #d3d3d3"
          >
            <thead>
              <!-- CINEMA NAME -->
              <tr class="bb">
                <td
                  colspan="3"
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  class="title"
                >
                  <p style="margin: 0" class="fw-bold">PVR Cinemas</p>
                  <p style="margin: 0" class="fs-10 px-15">Andheri - Mumbai</p>
                </td>
              </tr>

              <!-- CINEMAS ADDRESS -->
              <!-- <tr>
                <td colspan="3" class="">
                    <p class="fs-10 px-15">
                        Andheri - Mumbai
                    </p>
                </td>
            </tr> -->

              <!-- <tr>
                <td colspan="3"></td>
            </tr> -->
            </thead>

            <tbody>
              <tr class="pt-10">
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  colspan="3"
                >
                  <p style="margin: 0" class="fs-10">Movie:</p>
                  <p style="margin: 0" class="my-2 fw-bold">ABCD 2-Hindi-2D</p>
                  <p style="margin: 0" class="my-2">
                    ᣌانجل هاز فولة(ᗫᡧᢕᣂ)الانجل:
                  </p>
                </td>
              </tr>

              <tr>
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  colspan="2"
                >
                  <p style="margin: 0" class="fs-10">Theatre:</p>
                  <p style="margin: 0" class="fs-10">مسرح:</p>
                  <p style="margin: 0" class="my-2 fw-bold">Screen 1</p>
                </td>

                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  colspan="1"
                >
                  <p style="margin: 0" class="fs-10">Rating:</p>
                  <p style="margin: 0" class="fs-10">تقييم:</p>
                  <p style="margin: 0" class="my-2 fw-bold">PG</p>
                </td>
              </tr>

              <tr>
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                >
                  <p style="margin: 0" class="fs-10">Transaction ID:</p>
                  <p style="margin: 0" class="fs-10">رقم المعاملة:</p>
                  <p style="margin: 0" class="my-2 fw-bold">2F23F2GF2G</p>
                </td>

                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                >
                  <p style="margin: 0" class="fs-10">Date:</p>
                  <p style="margin: 0" class="fs-10">تاريخ:</p>
                  <p style="margin: 0" class="my-2 fw-bold">05-10-2020</p>
                </td>

                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                >
                  <p style="margin: 0" class="fs-10">TIME:</p>
                  <p style="margin: 0" class="fs-10">زمن:</p>
                  <p style="margin: 0" class="my-2 fw-bold">18:00</p>
                </td>
              </tr>

              <tr>
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                >
                  <p style="margin: 0" class="fs-10">Class:</p>
                  <p style="margin: 0" class="fs-10">صف دراسي:</p>
                  <p style="margin: 0" class="my-2 fw-bold">Gold</p>
                </td>

                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                >
                  <p style="margin: 0" class="fs-10">Seats:</p>
                  <p style="margin: 0" class="fs-10">مقاعد:</p>
                  <p style="margin: 0" class="my-2 fw-bold">A1, A2</p>
                </td>

                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                >
                  <p style="margin: 0" class="fs-10">Ticket:</p>
                  <p style="margin: 0" class="fs-10">تذكرة:</p>
                  <p style="margin: 0" class="my-2 fw-bold">215.00</p>
                </td>
              </tr>

              <!-- <tr>
                <td colspan="2">
                    <p class="fs-10">3D GLASS</p>
                    <p class="fs-10">Dظارات 3</p>
                </td>
                <td>
                    <p style="font-weight:bold;" >15.00</p>
                </td>
            </tr> -->
              <tr>
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  colSpan="3"
                >
                  <p class="fw-bold">Discounts:</p>
                </td>
              </tr>

              <tr>
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  colSpan="2"
                >
                  <p class="fs-10">Offer Name:</p>
                  <p class="fs-10">اسم العرض:</p>
                </td>
                <td colSpan="1">
                  <p style="margin: 0" class="fs-10">Offer Amount:</p>
                  <p style="margin: 0" class="fs-10">قيمة العرض:</p>
                </td>
              </tr>

              <tr>
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  colSpan="2"
                >
                  <p style="margin: 0">Paytm25</p>
                </td>

                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                >
                  <p style="margin: 0" class="fw-bold">25.00</p>
                </td>
              </tr>

              <tr>
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  colspan="1"
                >
                  <p style="margin: 0" class="fs-10">Base Amount:</p>
                  <p style="margin: 0" class="fs-10">كمية أساسية:</p>
                  <p style="margin: 0" class="my-2 fw-bold">200.00</p>
                </td>

                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  colspan="1"
                >
                  <p style="margin: 0" class="fs-10">Added Value VAT:</p>
                  <p style="margin: 0" class="fs-10">ضريبة القيمة المضافة:</p>
                  <p style="margin: 0" class="my-2 fw-bold">15.00</p>
                </td>

                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  colspan="1"
                >
                  <p style="margin: 0" class="fs-10">Total:</p>
                  <p style="margin: 0" class="fs-10">مجموع:</p>
                  <p style="margin: 0" class="my-2 fw-bold">215.00</p>
                </td>
              </tr>

              <tr class="bb">
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                ></td>
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  colspan="2"
                ></td>
              </tr>

              <tr class="pt-10">
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                >
                  <p style="margin: 0" class="fs-10">Transaction ID:</p>
                  <p style="margin: 0" class="my-2 fw-bold">276</p>
                </td>

                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                >
                  <p style="margin: 0" class="fs-10">Date:</p>
                  <p style="margin: 0" class="my-2 fw-bold">27/10/2019</p>
                </td>

                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                >
                  <p style="margin: 0" class="fs-10">Time:</p>
                  <p style="margin: 0" class="my-2 fw-bold">3:55 PM</p>
                </td>
              </tr>

              <tr>
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  colSpan="2"
                >
                  <p style="margin: 0">Theater</p>
                </td>

                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                >
                  <p style="margin: 0" class="fw-bold">SCREEN 4</p>
                </td>
              </tr>

              <tr>
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  colSpan="2"
                >
                  <p style="margin: 0">Movie</p>
                </td>

                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                >
                  <p style="margin: 0" class="fw-bold">ABCD 2-Hindi-2D</p>
                </td>
              </tr>

              <tr>
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  colSpan="2"
                >
                  <p style="margin: 0">Seats</p>
                </td>

                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                >
                  <p style="margin: 0" class="fw-bold">A-9 to 13</p>
                </td>
              </tr>

              <tr>
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  colSpan="2"
                >
                  <p style="margin: 0">Class</p>
                </td>

                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                >
                  <p style="margin: 0" class="fw-bold">PREMIUM</p>
                </td>
              </tr>

              <tr>
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  colSpan="2"
                >
                  <p style="margin: 0">Qty</p>
                </td>

                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                >
                  <p style="margin: 0" class="fw-bold">5</p>
                </td>
              </tr>

              <!-- <tr>
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  colSpan="2"
                >
                  <p style="margin: 0">Glass</p>
                </td>

                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                >
                  <p style="margin: 0" class="fw-bold">3D</p>
                </td>
              </tr> -->

              <tr>
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  colSpan="2"
                >
                  <p style="margin: 0">Qty</p>
                </td>

                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                >
                  <p style="margin: 0" class="fw-bold">5</p>
                </td>
              </tr>

              <tr>
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  colSpan="2"
                >
                  <p style="margin: 0">POS</p>
                </td>

                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                >
                  <p style="margin: 0" class="fw-bold">IT-Showbizz</p>
                </td>
              </tr>

              <tr class="">
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  colSpan="2"
                >
                  <p style="margin: 0">VAT is charged at 5%</p>
                </td>
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                >
                  <p style="margin: 0" class="fw-bold">12.62</p>
                </td>
              </tr>

              <tr class="total bt bb">
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                  colSpan="2"
                >
                  <p style="margin: 0">Total</p>
                </td>
                <td
                  style="
                    color: #404040;
                    font-size: 14px;
                    padding: 0 10px;
                    padding-bottom: 10px;
                  "
                >
                  <p style="margin: 0">265</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import moment from "moment";

export default {
  data() {
    return {
      id: "",
      ticketDetails: {
        temp_tt_id: "",
        temp_id: "",
        temp_name: "",
        temp_cinema_id: [],
        temp_no_of_copies_id: "",
        temp_active: "Y",
        temp_single_Ticket: "Y",
        temp_cinema_name: "Y",
        temp_contact_number: "N",
        temp_show_address: "Y",
        temp_email: "N",
        temp_screen_name: "Y",
        temp_seat_type: "Y",
        temp_seat_name: "Y",
        temp_tax_details: "N",
        temp_fnb_bill: "Y",
        temp_special_instruction: "N",
        temp_special_text: "",
        temp_datetime: "Y",
        temp_qrcode: "N",
      },
      cinema_name: "",
    };
  },
  beforeMount() {
    const { tt_id } = this.$route.query;
    this.id = tt_id;
    this.GetTicektTemplateDetails(tt_id);
  },

  methods: {
    goToRoute: function (path) {
      this.$router.push({
        path: path,
        query: { tt_id: this.id },
      });
    },

    GetTicektTemplateDetails: function (id) {
      let body = {
        temp_id: id,
      };
      MasterService.GetCinemaTicketTemplate(body).then((response) => {
        const { data } = response;

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            let obj = data.Records[0];

            this.ticketDetails.temp_tt_id = obj.tt_id;
            this.ticketDetails.temp_id = obj.template_id;
            this.ticketDetails.temp_name = obj.tt_name;
            this.getCinemaList(obj.cinema_id);

            this.ticketDetails.temp_no_of_copies_id = obj.tt_no_of_copy;
            this.copies_name = String(obj.tt_no_of_copy);
            this.ticketDetails.temp_active = obj.tt_is_active;
            this.ticketDetails.temp_single_Ticket = obj.tt_single_seat_ticket;
            this.ticketDetails.temp_cinema_name = obj.tt_show_cinema_name;
            this.ticketDetails.temp_contact_number = obj.tt_show_contact_no;
            this.ticketDetails.temp_show_address = obj.tt_show_address;
            this.ticketDetails.temp_email = obj.tt_show_support_email;
            this.ticketDetails.temp_screen_name = obj.tt_show_screen_name;
            this.ticketDetails.temp_seat_type = obj.tt_show_seat_type;
            this.ticketDetails.temp_seat_name = obj.tt_show_seat_name;
            this.ticketDetails.temp_tax_details = obj.tt_show_charge_details;
            this.ticketDetails.temp_fnb_bill = obj.tt_fnb_separate_ticket;
            this.ticketDetails.temp_special_instruction =
              obj.tt_show_instruction;
            this.ticketDetails.temp_special_text = obj.tt_instruction;
            this.ticketDetails.temp_datetime = obj.tt_show_date_time;
            this.ticketDetails.temp_qrcode = obj.tt_show_qr_code;
          }
        }
      });
    },

    getCinemaList: function (cine_id) {
      CinemasService.GetActiveCinemas({ activekey: "cine_is_active" })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.cinemaList = data.Records;
            if (cine_id === undefined) {
            } else {
              this.cinemaList.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  this.cinema_name = x.cine_name;
                  this.ticketDetails.temp_cinema_id = x.cine_id;
                }
              });
            }
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch On GetInActiveCinemas :", error);
        });
    },
  },
};
</script>

<style scoped>
.bl-5 {
  border-left: 3px solid #000000;
}

.bt {
  border-top: 1px dashed #404040;
}

.bb {
  border-bottom: 1px dashed #404040;
}

.title {
  padding-top: 15px;
}

.title p {
  text-align: center;
}

.fw-bold {
  font-weight: bold;
}

.fs-10 {
  font-size: 10px;
}

.my-2 {
  margin: 2px 0;
}

.pt-10 td {
  padding-top: 10px;
}

.total td {
  font-size: 16px;
  font-weight: bold;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CinemaTicketTemplates/viewCinemaTicketTemplates.vue